import * as React from "react";
const SvgPostAdd = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 19.22H5V7h7V5H3v16h16v-9h-2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zm0 3v2h8v-2h-3zm0 3h8v2H7z",
  fill: "currentColor"
}));
export default SvgPostAdd;